import React from 'react';
import { Dropdown, DropdownToggle, DropdownMenu, DropdownItem } from 'reactstrap';

export default class LegalDropdown extends React.Component {
  constructor(props) {
    super(props);

    this.toggle = this.toggle.bind(this);
    this.state = {
      dropdownOpen: false,
      dropDownValue: "Match Type"
    };
    
  }

  toggle() {
    this.setState(prevState => ({
      dropdownOpen: !prevState.dropdownOpen
    }));
  }

  changeValue(e) {
    this.setState({dropDownValue: e.target.value})
  }

  render() {
    return (
      <Dropdown isOpen={this.state.dropdownOpen} toggle={this.toggle}>
        <DropdownToggle caret>
          {this.state.dropDownValue}
        </DropdownToggle>
        <DropdownMenu>
          <DropdownItem name="legalMatchType" value="Exact" onClick={(e) => {this.changeValue(e); this.props.handleLegalDropdown(e)}}>Exact</DropdownItem>
          <DropdownItem name="legalMatchType" value="Likely" onClick={(e) => {this.changeValue(e); this.props.handleLegalDropdown(e)}}>Likely</DropdownItem>
        </DropdownMenu>
      </Dropdown>
    );
  }
}